import React from "react";
import { useSelector } from "react-redux";
import EmptyFolder from "../../../components/EmptyFolder";
import { useTranslation } from "react-i18next";
import FileFolderCard from "../../../components/FileFolderCard";

const SubFolder = () => {
  const { files } = useSelector((state) => state.fileSlice);
  const { t } = useTranslation();

  return (
    <section className="media-gallery">
      {files?.length ? (
        <div className="media-gallery__grid">
          {files.map((file) => {
            const folderName = file?.folderName?.split("/").pop();

            return (
              <FileFolderCard
                key={file.file.fileId}
                isSub={true}
                icon={false}
                name={folderName}
                directory={file?.folderName}
                thumbnailUrl={file?.file?.thumbnailUrl}
                isNav="file"
                actualImage={file?.originalUrl}
                ext={file.originalFileExt}
                fileId={file.file.fileId}
                itemCount={file.count}
                fileSize={file.file.size}
                fileDate={file.file.createdAt}
              />
            );
          })}
        </div>
      ) : (
        <EmptyFolder title={`${t("messages.folderEmptyTitle")}`} />
      )}
    </section>
  );
};

export default SubFolder;
